import type { ReactNode } from 'react'
import { AppStatusState } from './AppStatusState'

export interface AppErrorStateProps {
  readonly message: ReactNode
  readonly minHeight?: number | string
  readonly title?: ReactNode
}

export function AppErrorState({
  message,
  minHeight,
  title = 'We could not load this content',
}: AppErrorStateProps) {
  return (
    <AppStatusState
      message={message}
      minHeight={minHeight}
      title={title}
      tone="error"
    />
  )
}
